import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Autocomplete, AutocompleteItem, Tab, Tabs } from "@heroui/react";

import { memo, useState } from 'react';
import isEqual from 'react-fast-compare';
// @ts-ignore
import iconData from '@/data/icon.json';
import SheetWrapper, {
  SheetWrapperHeader,
} from '@/components/SheetWrapper/index.jsx';
import { hooks } from '@/store.js';

interface IProps {
  planId: string;
  defaultValue?: string;
  id: string;
}
function parseIconString(iconString?: string) {
  // 初始化结果对象
  const result = { type: 'outline', icon: '' };

  if (!iconString) return result;
  // 分割字符串为数组
  const parts = iconString.split(' ');

  // 遍历每个部分
  // biome-ignore lint/complexity/noForEach: <explanation>
  parts.forEach((part) => {
    if (part.startsWith('ic-')) {
      // 提取类型
      result.type = part.replace('ic-', '');
    } else if (part.startsWith('md-')) {
      // 提取图标名称
      result.icon = part.replace('md-', '');
    }
  });

  return result;
}
const Content = memo(
  ({ id, onClose, defaultValue }: IProps & { onClose: () => void }) => {
    const parseDefaultValue = parseIconString(defaultValue);
    const [type, setType] = useState(parseDefaultValue.type);
    const [icon, setIcon] = useState(parseDefaultValue.icon);
    const client = hooks.useClient();

    return (
      <>
        <SheetWrapperHeader
          title='更改图标'
          onOk={async () => {
            (await client.events.get(id).resolved)?.set(
              'icon',
              `ic-${type} md-${icon}`
            );
            onClose();
          }}
        />
        <div className='py-10 px-6 flex'>
          <div className=' rounded-2xl bg-gray-100 w-20 h-20 shrink-0 mr-6 flex items-center justify-center'>
            <i className={`ic-${type} md-${icon} text-4xl  `} />
          </div>
          <div className=' '>
            {/* @ts-ignore children */}
            <Tabs
              selectedKey={type}
              onSelectionChange={setType}
              className='mb-4'
            >
              {[
                { label: '边框', value: 'outline' },
                { label: '圆润', value: 'round' },
                { label: '双色', value: 'twotone' },
                { label: '锋利', value: 'sharp' },
              ].map((i) => (
                <Tab key={i.value} title={i.label} />
              ))}
            </Tabs>
            {/* @ts-ignore children */}
            <Autocomplete
              size='lg'
              aria-label='icon'
              placeholder='搜索图标'
              isVirtualized
              onSelectionChange={setIcon}
              defaultSelectedKey={icon}
            >
              {iconData.map((i) => (
                <AutocompleteItem key={i} textValue={i}>
                  <i
                    className={`ic-${type} md-${i} inline-block align-middle mr-2`}
                  />
                  {i}
                </AutocompleteItem>
              ))}
            </Autocomplete>
          </div>
        </div>
      </>
    );
  },
  isEqual
);

const ChangeIcon = NiceModal.create((props: IProps) => {
  const [closeKey, setCloseKey] = useState(0);
  return (
    <SheetWrapper closeKey={closeKey}>
      <Content {...props} onClose={() => setCloseKey(+new Date())} />
    </SheetWrapper>
  );
});

export const UseChangeIcon = () => {
  const moveToModal = useModal(ChangeIcon);
  return {
    show: moveToModal.show,
  };
};
